import {useEffect, useMemo, useState} from 'react';

import chunk from 'lodash.chunk';
import useIntersection from 'src/hooks/useIntersection';

const DEFAULT_PAGE_SIZE = 50;

export const usePagination = <T>(rows: Array<T>, pageSize: number = DEFAULT_PAGE_SIZE) => {
    const [intersectRef, isVisible] = useIntersection();
    const [page, setPage] = useState(1);
    const chunkedRows = chunk(rows, pageSize);
    const slicedRowsByPage = useMemo(() => chunkedRows.slice(0, page).flat(), [chunkedRows, page]);

    const hasMore = page < chunkedRows.length;

    useEffect(() => {
        if (isVisible && hasMore) {
            setPage(prevPage => ++prevPage);
        }
    }, [hasMore, isVisible]);

    const goToPage = (pageNumber: number) => {
        setPage(pageNumber);
    };

    return {slicedRowsByPage, hasMore, intersectRef, isVisible, goToPage};
};
